<template>
  <div style="display: contents;">
    <tr>
      <td width="1%">
        <b-icon :icon="collapsed ? 'dash-square': 'plus-square'" variant="dark" scale="1.1" @click="collapsed = !collapsed"/>
      </td>
      <td><a href="" @click.prevent="$emit('view')" class="text-dark font-weight-bold">{{ booking.id }}</a></td>
      <td>{{ toDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
      <td>
        <span class="text-warning" v-if="booking.supplier_status === 'option' "><b>OPT</b></span>
        <span class="text-success" v-if="booking.supplier_status === 'confirmed'"><b>CONF</b></span>
        <span class="text-danger" v-if="booking.supplier_status === 'on_request' "><b>REQ</b></span>
      </td>
      <td>{{ booking.client_ref }}</td>
      <td><b>{{ booking.lead_name }}</b></td>
      <td>{{ booking.gross + booking.tax }} {{ booking.currency}}</td>
      <td>{{ booking.paid_amount }} {{ booking.currency}}</td>
      <td>{{ booking.gross + booking.tax - booking.commission - booking.paid_amount }} {{ booking.currency}}</td>
      <td>{{ toDate(booking.balance_due_date, 'DD-MM-YYYY') }}</td>
    </tr>
    <template v-if="collapsed">
      <PackageItemResult
        v-for="(item, itemIndex) in booking.packages"
        :item="item"
        :booking="booking"
        :key="'item' + itemIndex" />
      <BookingItemResult
        v-for="(item, itemIndex) in booking.items"
        :item="item"
        :booking="booking"
        :key="'item' + itemIndex" />
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import BookingItemResult from './booking_item_result'
import PackageItemResult from './package_item_result'

export default {
  name: 'BookingResult',
  props: ['booking'],
  components: { BookingItemResult, PackageItemResult },
  data () {
    return {
      collapsed: false,
      secondCollapsed: false
    }
  },
  methods: {
    toDate (date, format) {
      return moment.unix(date).format(format)
    }
  }
}
</script>
